import { render, staticRenderFns } from "./AddFlyer.vue?vue&type=template&id=08da7897&"
import script from "./AddFlyer.vue?vue&type=script&lang=js&"
export * from "./AddFlyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports